import { CheckCircle } from "@lazarentertainment/web-design-system/components/iconOutline"
import { Button } from "client/designSystem/Button"
import { FormattedMessage } from "react-intl"

import styles from "./EntrySubmittedMessage.module.css"

type EntrySubmittedMessageProps = {
  onClose: () => void
}

/**
 * Message shown after entry is submitted.
 */
export default function EntrySubmittedMessage({
  onClose,
}: EntrySubmittedMessageProps) {
  return (
    <div className={styles.container}>
      <CheckCircle color="rgb(var(--success-500))" data-size="lg" />
      <p className="body-md">
        <FormattedMessage
          defaultMessage="The host will announce the results of the giveaway shortly."
          id="giveaways.entrySubmittedMessage.message"
        />
      </p>
      <Button
        data-full-width
        type="submit"
        variant="outline"
        onClick={onClose}
      >
        Close
      </Button>
    </div>
  )
}
